import { ResolveInviteLinkResponse } from "../../types/invites";

export const resolveInviteLinkModel = (
  response: ResolveInviteLinkResponse
): ResolveInviteLinkResponse => response;
